import { NotificationChoiceColumn } from '../interfaces/notification-choice-column.interface';

const prefix = 'user-profile.notifications.table';

export const USER_PROFILE_NOTIFICATIONS_COLUMNS: NotificationChoiceColumn[] = [
  {
    id: 'title',
    label: `${prefix}.type.title`,
  },
  {
    id: 'email',
    label: `${prefix}.email`,
  },
  {
    id: 'sms',
    label: `${prefix}.sms`,
  },
  {
    id: 'pushNotification',
    label: `${prefix}.pushNotification`,
  },
];
